"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPageSizes = void 0;
const types_1 = require("./types");
exports.defaultPageSizes = [10, 25, 50, 100, types_1.AllItemsPerPage];
